import React, { useState } from "react";
import emailjs from 'emailjs-com';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setMessage("Veuillez entrer une adresse email valide");
      setIsError(true);
      return;
    }
    
    try {
      // Envoi de l'email avec EmailJS
      await emailjs.send(
        'service_5b58o8q',
        'template_8tnf8vk',
        {
          to_email: 'rafikbj@gmail.com',
          subscriber_email: email,
          date: new Date().toLocaleDateString('fr-FR'),
          time: new Date().toLocaleTimeString('fr-FR'),
          year: new Date().getFullYear()
        },
        'lV6-QVLOJBI_Bz9Co'
      );
      
      setMessage("Merci pour votre inscription !");
      setIsError(false);
      setEmail("");
    } catch (error) {
      console.error("Erreur EmailJS:", error);
      setMessage("Une erreur s'est produite. Veuillez réessayer.");
      setIsError(true);
    }
  };

console.log('Envoi avec:', {
  service: 'service_5b58o8q',
  template: 'template_8tnf8vk', 
  user: 'L-QVLOJBI_Bz9Co'
});

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const openItinerary = () => {
    const address = "l'îlot U17B, El Morjane, Tabarka, Jendouba, Tunisie";
    const encodedAddress = encodeURIComponent(address);
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`, '_blank');
  };

  return (
    <footer className="footer">
      <div className="footer_top">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-md-6 col-lg-3">
              <div className="footer_widget">
                <h3 className="footer_title">Address</h3>
                <p className="footer_text">
                  l'îlot U17B, El Morjane, <br />
                  Tabarka, Jendouba, Tunisia
                </p>
                <a href="#" className="line-button" onClick={openItinerary}>
                  Directions
                </a>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 col-lg-3">
              <div className="footer_widget">
                <h3 className="footer_title">Reservation</h3>
                <p className="footer_text">
                  +216 98 370 055 <br />
                  rafikbj@gmail.com
                </p>
              </div>
            </div>
            <div className="col-xl-2 col-md-6 col-lg-2">
              <div className="footer_widget">
                <h3 className="footer_title">Navigation</h3>
                <ul>
                  <li>
                    <a href="/" onClick={(e) => { e.preventDefault(); handleNavigation('/'); }}>
                      Home
                    </a>
                  </li>
                  <li>
                    <a href="/about" onClick={(e) => { e.preventDefault(); handleNavigation('/about'); }}>
                      About
                    </a>
                  </li>
                  <li>
                    <a href="/gallery" onClick={(e) => { e.preventDefault(); handleNavigation('/gallery'); }}>
                      Gallery
                    </a>
                  </li>
                  <li>
                    <a href="/contact" onClick={(e) => { e.preventDefault(); handleNavigation('/contact'); }}>
                      Contact us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 col-lg-4">
              <div className="footer_widget">
                <h3 className="footer_title">Newsletter</h3>
                <form onSubmit={handleSubmit} className="newsletter_form">
                  <input
                    type="text"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button type="submit">Sign Up</button>
                </form>
                {message && (
                  <div className={isError ? "error_message" : "success_message"}>
                    {message}
                  </div>
                )}
                <p className="newsletter_text">Subscribe to the newsletter to receive our updates</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copy-right_text">
        <div className="container">
          <div className="footer_border"></div>
          <div className="row">
            <div className="col-xl-8 col-md-7 col-lg-9">
              <p className="copy_right">
                Copyright &copy;{new Date().getFullYear()} All rights reserved | By{" "}
                <a href="" target="_blank" rel="noopener noreferrer">
                  Amine Makni
                </a>
              </p>
            </div>
            <div className="col-xl-4 col-md-5 col-lg-3">
              <div className="socail_links">
                <ul>
                  <li>
                    <a href="#">
                      <i className="fa fa-facebook-square"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    
    </footer>
  );
};

export default Footer;
